import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "../Button";
import { faExpand } from "@fortawesome/free-solid-svg-icons";
import screenfull from "screenfull";
import { useVideoPlayerRefs } from "../../contexts/VideoPlayerRefs";
import { useRef } from "react";

export const FullscreenButton = () => {
  const { container } = useVideoPlayerRefs();

  const ref = useRef<HTMLButtonElement>(null);

  const onClick = () => {
    if (screenfull.isEnabled && container.current !== null) {
      screenfull.toggle(container.current);

      if (ref.current !== null) {
        ref.current.blur();
      }
    }
  };

  const style = { height: 28 };

  return (
    <Button ref={ref} onClick={onClick}>
      <FontAwesomeIcon style={style} icon={faExpand} />
    </Button>
  );
};
